module.exports = __webpack_public_path__ + "static/media/arles_amphi_tn.87bacad1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/arles_amphi_tn.jpg
// module id = 704
// module chunks = 0